/*!
 * @piconetworks/heading v2.1.31
 * (c) 
 */
'use strict';

var cx = require('classnames');
var PropTypes = require('prop-types');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var H1 = function H1(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/React__default['default'].createElement("h1", _extends({
    className: cx__default['default'](className)
  }, props, {
    "data-testid": "H1_index_h1"
  }), children);
};

H1.propTypes = {
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object])
};

var H2 = function H2(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/React__default['default'].createElement("h2", _extends({
    className: cx__default['default'](className)
  }, props, {
    "data-testid": "H2_index_h2"
  }), children);
};

H2.propTypes = {
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object])
};

var H3 = function H3(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  return /*#__PURE__*/React__default['default'].createElement("h3", _extends({
    className: cx__default['default'](className)
  }, props, {
    "data-testid": "H3_index_h3"
  }), children);
};

H3.propTypes = {
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object])
};

var H4 = function H4(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  return /*#__PURE__*/React__default['default'].createElement("h4", _extends({
    className: cx__default['default'](className)
  }, props, {
    "data-testid": "H4_index_h4"
  }), children);
};

H4.propTypes = {
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object])
};

var H5 = function H5(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  return /*#__PURE__*/React__default['default'].createElement("h5", _extends({
    className: cx__default['default'](className)
  }, props, {
    "data-testid": "H5_index_h5"
  }), children);
};

H5.propTypes = {
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object])
};

var Heading = {
  H1: H1,
  H2: H2,
  H3: H3,
  H4: H4,
  H5: H5
};

module.exports = Heading;
